import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import * as Styled from "./styles";

type TotalValueProps = {
  value: number;
};

const TotalValue = ({ value }: TotalValueProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {t("totalSalesValue")}
      </Typography>
      <Styled.Row>
        <Typography margin={0} gutterBottom component="div">
          R$
        </Typography>
        <Typography
          margin={0}
          gutterBottom
          variant="h3"
          component="div"
          marginLeft={1}
        >
          {value.toLocaleString("pt-BR", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })}
        </Typography>
      </Styled.Row>
    </>
  );
};

export default TotalValue;
